import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import UserDisplayNameModel from '../models/UserDisplayNameModel';

interface UserSelectorState {
    userDisplayNames: UserDisplayNameModel[],
}

const initialState: UserSelectorState = {
    userDisplayNames: [],
}

export const UserSelectorSlice = createSlice({
    name: "userSelector",
    initialState,
    reducers: {
        setUserDisplayNames: (state, action: PayloadAction<UserDisplayNameModel[]>) => {
            state.userDisplayNames = action.payload;
        },
    }
});

export const userSelectorSelector = createSelector(
    (state: RootState) => state.userSelector,
    (data) => data
);

export const {
    setUserDisplayNames,
} = UserSelectorSlice.actions;

export default UserSelectorSlice.reducer;